var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageReactionIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 333.98 265.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #6d6d6d;\n      }\n\n      .cls-2 {\n        fill: #e2e2e2;\n      }\n\n      .cls-3 {\n        fill: #1e1e1e;\n      }\n\n      .cls-4 {\n        fill: #7fdbc9;\n      }\n\n      .cls-5 {\n        fill: #64938d;\n      }\n\n      .cls-6 {\n        fill: #487c74;\n      }\n\n      .cls-7 {\n        fill: #273d3b;\n      }\n\n      .cls-8 {\n        fill: #4c4c4c;\n      }\n\n      .cls-9 {\n        fill: #999;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "77.09 179.36 166.86 158.08 256.4 179.36 238.08 230.25 166.59 260.91 95.11 230.25 77.09 179.36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "34.4 119.28 7.4 119.28 0 94.78 .4 80.28 20.61 70.28 32.55 90.28 38.4 94.28 34.4 119.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "57.4 163.28 80.4 188.28 74.4 251.28 23 176.34 6.57 119.13 35.4 117.28 57.4 163.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "276.58 164.28 253.58 189.28 259.58 252.28 310.98 177.34 327.41 120.13 298.58 118.28 276.58 164.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "275.64 170.19 166.59 209.31 57.55 170.19 65.16 103.41 126.3 49.91 166.59 45.01 208.82 51.37 269.07 104.45 275.64 170.19"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "120.7 192.94 71.12 174.76 71.12 150.55 108.48 97.85 166.85 81.56 194.69 130.43 120.7 192.94"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "214.1 193.06 263.68 174.88 263.68 150.68 226.32 97.98 167.95 81.69 140.12 130.56 214.1 193.06"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "263.4 265.28 71.4 265.28 80.4 188.28 166.59 159.7 253.4 189.28 263.4 265.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "207.94 243.1 166.86 259.23 125.25 243.1 114.49 187.1 218.7 187.1 207.94 243.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "227.55 121.56 181.29 108.65 167.1 123.19 152.34 108.06 106.08 120.97 81.34 155.39 74.89 176.37 131.9 198.42 166.56 161.34 201.73 199.01 258.74 176.42 252.29 155.99 227.55 121.56"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "209.07 198.17 166.64 209.16 124.21 198.17 132.91 165.77 166.64 150.48 200.82 166.23 209.07 198.17"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "175.47 104.08 166.86 150.55 158.26 104.08 156.64 51.58 167.13 45.13 177.08 51.58 175.47 104.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "180.65 203.22 166.59 206.49 152.54 203.22 151.38 185.06 166.87 178.52 181.81 185.06 180.65 203.22"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "253.1 108.87 196 51.77 248.01 0 267.79 16.48 253.1 108.87"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "246.64 96.13 207.07 56.56 243.12 20.68 256.82 32.1 246.64 96.13"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-9",
    points: "77.64 110.08 134.85 52.86 82.73 .99 62.92 17.5 77.64 110.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "84.11 97.31 123.76 57.66 87.64 21.72 73.91 33.16 84.11 97.31"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "177.74 148.1 206.13 152.71 228.23 136.78 193.61 123.58 177.74 148.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "155.99 148.1 127.59 152.71 105.5 136.78 140.12 123.58 155.99 148.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "277.88 150.26 286.63 71.71 275.47 61.91 262.57 69.03 253.82 147.58 264.83 157.36 277.88 150.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "274.19 114.06 283.02 34.83 278.92 28.9 273.67 33.79 264.84 113.02 268.88 118.95 274.19 114.06"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "52.88 150.26 44.12 71.71 55.29 61.91 68.18 69.03 76.93 147.58 65.92 157.36 52.88 150.26"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "56.5 116.22 47.68 37.05 52.08 31.09 57.62 35.95 66.44 115.11 62.11 121.06 56.5 116.22"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "299.58 120.28 326.58 120.28 333.98 95.78 333.58 81.28 313.37 71.28 301.43 91.28 295.58 95.28 299.58 120.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "44.4 135.28 11.4 137.28 9.4 130.28 40.4 128.28 44.4 135.28"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "289.29 135.28 322.29 137.28 324.29 130.28 293.29 128.28 289.29 135.28"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageReactionIcon);
export default __webpack_public_path__ + "static/media/message-reaction-icon.5e16234c0682b60610b156aa94ccbba8.svg";
export { ForwardRef as ReactComponent };